import Vue from "vue";
import { isStandalone } from "./webPush";

// Expose PostHog on Vue prototype for easy access in components
const posthog = window.posthog || null;
Vue.prototype.$posthog = posthog;

/**
 * Carimba em TODO evento se o app está aberto instalado ou numa aba.
 *
 * Como super-property, os eventos de push que já existem passam a ser
 * fatiáveis por instalado-vs-navegador sem instrumentar nada de novo.
 */
function registerDisplayMode() {
  try {
    if (!window.posthog || typeof window.posthog.register !== "function") return;
    window.posthog.register({
      display_mode: isStandalone() ? "standalone" : "browser",
    });
  } catch (_) {
    // no-op
  }
}

registerDisplayMode();

// Helper: identify by distinct id (email) and send properties if provided
export function identifyTalent(distinctId, props = {}) {
  try {
    if (!window.posthog || !distinctId) return;
    const payload = {};
    if (props.email) payload.email = props.email;
    if (props.name) payload.name = props.name;
    if (props.last_company_label) payload.last_company_label = props.last_company_label;
    window.posthog.identify(String(distinctId), payload);
  } catch (_) {
    // no-op
  }
}

// Helper: track new application with optional properties
export function trackNewApplication(props = {}) {
  try {
    if (!window.posthog) return;
    const payload = {};
    if (props.vacancy_id !== undefined) payload.vacancy_id = props.vacancy_id;
    if (props.vacancy_title !== undefined) payload.vacancy_title = props.vacancy_title;
    if (props.company_id !== undefined) payload.company_id = props.company_id;
    if (props.company_name !== undefined) payload.company_name = props.company_name;
    if (props.company_label !== undefined) payload.company_label = props.company_label;
    if (props.channel !== undefined) payload.channel = props.channel;
    // Default vacancy title if no vacancy is present
    const hasVacancy = payload.vacancy_id !== undefined && payload.vacancy_id !== null;
    if (!hasVacancy && payload.vacancy_title === undefined) {
      payload.vacancy_title = "Banco de Talentos";
    }
    window.posthog.capture("new_application", payload);
  } catch (_) {
    // no-op
  }
}

// Generic event tracker
export function trackEvent(eventName, props = {}) {
  try {
    if (!window.posthog) return;
    window.posthog.capture(eventName, props || {});
  } catch (_) {
    // no-op
  }
}


